import { getClientByDomain, getParameterByName, isDev } from './helpers';
import { hydrate, render } from 'react-dom';

import App from './App';
import React from 'react';

const clientCode =
	getParameterByName('client') ||
	getClientByDomain(window.location.hostname) ||
	'AOL';
const isPreview = getParameterByName('isPreview') ? true : false;

const windowObjectDefaultProps = {
	isEnabled: true,
};

if (window && window.AOSearchWidget) {
	window.AOSearchWidget = {
		...window.AOSearchWidget,
		...windowObjectDefaultProps,
	};
} else if (window) {
	window.AOSearchWidget = { ...windowObjectDefaultProps };
}
const APP = <App clientCode={clientCode.toUpperCase()} isPreview={isPreview} />;
const RENDER_ELEMENTS = document.querySelectorAll('#search-root');

if (isDev) {
	RENDER_ELEMENTS.forEach((RENDER_EL) => {
		render(APP, RENDER_EL);
	});
} else {
	RENDER_ELEMENTS.forEach((RENDER_EL) => {
		hydrate(APP, RENDER_EL);
	});
}
